import { render, staticRenderFns } from "./_Support.vue?vue&type=template&id=e5b0fb7e&"
import script from "./_Support.vue?vue&type=script&lang=ts&"
export * from "./_Support.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports